import { BOOKING_TYPE } from 'constants/booking_types';
import { PROPERTY_CHANNELS } from 'constants/property_channels';

const isAccommodationProperty = propertyType => {
  return propertyType === PROPERTY_CHANNELS.HOTEL || propertyType === BOOKING_TYPE.ACCOMMODATION;
};

export default isAccommodationProperty;
